import { render, staticRenderFns } from "./LocationAdd.vue?vue&type=template&id=2be1cb36&scoped=true&"
import script from "./LocationAdd.vue?vue&type=script&lang=js&"
export * from "./LocationAdd.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdd.vue?vue&type=style&index=0&id=2be1cb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1cb36",
  null
  
)

export default component.exports